import {
  Box,
  Input,
  InputGroup,
  InputLeftAddon,
  Select,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import React, { useState } from "react";
const countries = require("countrycitystatejson");

export const ProfileInputField = ({
  type2,
  type3,
  label,
  placeholder,
  type,
  value,
  name,
  handleChange,
  setCountryCode,
}) => {
  const textLabelColor = useColorModeValue("#000", "#343434");
  const textLabelColor2 = useColorModeValue("#000", "#636363");
  const inputBgColor = useColorModeValue("#fff", "#000000");
  const inputColor = useColorModeValue("#343434", "#707070");
  const shadowBgColor = useColorModeValue("#80808003", "none");

  return type3 ? (
    <InputGroup
      fontSize={"sm"}
      color={inputColor}
      bg={inputBgColor}
      borderRadius="20px"
      my="15px"
    >
      <InputLeftAddon
        children={
          <>
            <Select
              size={"xs"}
              defaultValue="+234"
              maxW="70px"
              onChange={(e) => setCountryCode(e.target.value)}
            >
              {countries?.getCountries()?.map((data, idx) => {
                return (
                  <option key={idx} value={`+${data?.phone}`}>
                    {`+${data?.phone}`}
                  </option>
                );
              })}
            </Select>
          </>
        }
      />

      <Input
        borderRadius="20px"
        type="number"
        onChange={handleChange}
        placeholder="Phone Number"
        value={value}
        fontSize={".8em"}
      />
    </InputGroup>
  ) : (
    <Box color="#343434" mb="15px">
      {type2 ? (
        <Text
          mb="6px"
          color={textLabelColor2}
          fontSize=".8em"
          fontWeight={"300"}
          textAlign="center"
        >
          {label} <span style={{ color: "red" }}>*</span>
        </Text>
      ) : (
        <Text
          mb="6px"
          color={textLabelColor}
          fontSize=".8em"
          fontWeight={"300"}
        >
          {label}
        </Text>
      )}
      <Input
        fontSize={".8em"}
        color={inputColor}
        bg={inputBgColor}
        boxShadow={`3px 8px 13px 0px ${shadowBgColor}`}
        height="40px"
        width="320px"
        borderRadius="25px"
        placeholder={placeholder}
        type={type}
        name={name}
        value={value}
        onChange={handleChange}
      />
    </Box>
  );
};
